// CardOneBtn.tsx
/*
Despliega la botonera con los estados del vehículo.

Autor: Benjamín León
Fecha: 2024-08-01
Modificaciones
--------------------
BLC, 2025-03-17: Movemos afuera el estado, y lo pasamos como parámetro (propiedad)
*/
import React from 'react'

import { AppPath } from '../enums/AppPath'

import { ButtonMenuSet } from './Buttons'

interface CardOneBtnProps {
  docuType: string
  //setCardData: React.Dispatch<React.SetStateAction<CardOneData[]>>;
  handleButtonClick: (estado: number) => void
  clickedIndex: number
}

const CardOneBtn: React.FC<CardOneBtnProps> = ({ docuType, handleButtonClick, clickedIndex }) => {
  // Elindex es el boton clickeado.

  let buttonCaptions: string[] = []

  switch (docuType) {
    case AppPath.Consignments:
      buttonCaptions = ['Activas', 'Nulas', 'Archivadas']
      break
    case AppPath.Estimates:
      buttonCaptions = ['Vigentes', 'Expiradas', 'Nulas']
      break
    case AppPath.SaleNotes:
      buttonCaptions = ['Pendientes', 'Aprobadas', 'Nulas']
      break
    case AppPath.Settlements:
      buttonCaptions = ['Activas', 'Nulas']
      break
    case AppPath.Purchases:
      buttonCaptions = ['Válidas', 'Nulas']
      break
    case AppPath.Reservations:
      buttonCaptions = ['Activas', 'Completadas', 'Archivadas', 'Nulas']
      break
    case AppPath.Vehicles:
      buttonCaptions = ['Publicados', 'Pendientes', 'Reservados', 'Vendidos', 'Archivados']
      break
    case AppPath.Deals:
      buttonCaptions = ['En curso', 'Completados', 'Cancelados']
      break
  }

  return <ButtonMenuSet captions={buttonCaptions} clickedIndex={clickedIndex} handleButtonClick={handleButtonClick} />
}

export default CardOneBtn
